import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProofMap } from '@/components/ProofMap';
import { ScrollRestoration } from '@/components/ScrollRestoration';
import Home from '@/routes/Home';
import Services from '@/routes/Services';
import About from '@/routes/About';
import WorkWithMe from '@/routes/WorkWithMe';
import Articles from '@/routes/Articles';
import OperatingCanvas from '@/routes/articles/OperatingCanvas';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollRestoration />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/proof" element={<ProofMap />} />
          <Route path="/services" element={<Services />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/operating-canvas" element={<OperatingCanvas />} />
          <Route path="/work-with-me" element={<WorkWithMe />} />
          <Route path="/intake" element={<WorkWithMe />} />
          <Route path="/about" element={<About />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
